<div class="pb-6 text-4xl leading-none font-extrabold tracking-tight">{{ title() }}</div>
@if (currentUser(); as user) {
  <aura-internationalization-language-edit
    [initialLanguage]="user.settings.internationalization.language"
    [closeEditing]="closeIdentityEditing()"
    (saved)="saveLanguage($event)"
  />
  <aura-internationalization-timezone-edit
    [initialTimezone]="user.settings.internationalization.timezone"
    [closeEditing]="closeIdentityEditing()"
    (saved)="saveTimezone($event)"
  />
  <aura-internationalization-currency-edit
    [initialCurrency]="user.settings.internationalization.currency"
    [closeEditing]="closeIdentityEditing()"
    (saved)="saveCurrency($event)"
  />
}
